import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * DGRoute - Protected route for Director General / Admin
 * Allows access if: user's real role is admin/dg, OR activeRole is admin/dg (preview)
 */
const DGRoute = ({ children }) => {
  const { user, loading, isRealAdmin, previewMode, activeRole } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-pcc-bg">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-pcc-text-muted"></div>
      </div>
    );
  }

  // Allow if real admin/DG (even during preview of other roles)
  if (!user || (!isRealAdmin() && !['admin', 'dg'].includes(activeRole))) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default DGRoute;
